import React from 'react';
import { footerData } from '../data/mock';
import { Twitter, Linkedin, Facebook, Instagram, ArrowRight } from 'lucide-react';

const Footer = () => {
  const socialIcons = {
    twitter: Twitter,
    linkedin: Linkedin,
    facebook: Facebook,
    instagram: Instagram
  };

  return (
    <footer className="bg-gradient-to-br from-[#2D3748] via-[#1A202C] to-[#0F1419] text-slate-300 pt-20 pb-10 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#8B3A3A] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Column - Larger */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <div className="flex flex-col leading-tight mb-4">
                <span className="text-2xl font-black tracking-tight text-white">POLICY ARTH</span>
                <span className="text-sm font-semibold tracking-[0.2em] uppercase text-slate-400">Labs</span>
              </div>
            </div>
            <p className="text-slate-400 mb-8 leading-relaxed max-w-md text-lg">
              {footerData.description}
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              {Object.entries(footerData.social).map(([platform, href]) => {
                const IconComponent = socialIcons[platform];
                return (
                  <a
                    key={platform}
                    href={href}
                    className="group w-12 h-12 bg-white/5 hover:bg-gradient-to-br hover:from-[#8B3A3A] hover:to-[#6B2A2A] rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 border border-white/10 hover:border-transparent"
                    aria-label={platform}
                  >
                    {IconComponent && <IconComponent className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors" />}
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-black text-lg mb-6 flex items-center gap-2">
              Quick Links
              <div className="h-px flex-1 bg-gradient-to-r from-[#8B3A3A]/50 to-transparent"></div>
            </h3>
            <ul className="space-y-4">
              {footerData.quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="group flex items-center gap-2 hover:text-[#8B3A3A] transition-all duration-300"
                  >
                    <ArrowRight className="w-0 h-4 group-hover:w-4 transition-all duration-300 text-[#8B3A3A]" />
                    <span className="group-hover:translate-x-1 transition-transform duration-300">{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-black text-lg mb-6 flex items-center gap-2">
              Resources
              <div className="h-px flex-1 bg-gradient-to-r from-[#8B3A3A]/50 to-transparent"></div>
            </h3>
            <ul className="space-y-4">
              {footerData.resources.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="group flex items-center gap-2 hover:text-[#8B3A3A] transition-all duration-300"
                  >
                    <ArrowRight className="w-0 h-4 group-hover:w-4 transition-all duration-300 text-[#8B3A3A]" />
                    <span className="group-hover:translate-x-1 transition-transform duration-300">{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-black text-lg mb-6 flex items-center gap-2">
              Legal
              <div className="h-px flex-1 bg-gradient-to-r from-[#8B3A3A]/50 to-transparent"></div>
            </h3>
            <ul className="space-y-4">
              {footerData.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="group flex items-center gap-2 hover:text-[#8B3A3A] transition-all duration-300"
                  >
                    <ArrowRight className="w-0 h-4 group-hover:w-4 transition-all duration-300 text-[#8B3A3A]" />
                    <span className="group-hover:translate-x-1 transition-transform duration-300">{link.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-10 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-center md:text-left">
              © 2025 <span className="text-white font-semibold">POLICY ARTH Labs</span>. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-slate-500">
              <a href="#" className="hover:text-[#8B3A3A] transition-colors">Privacy Policy</a>
              <span>•</span>
              <a href="#" className="hover:text-[#8B3A3A] transition-colors">Terms of Service</a>
              <span>•</span>
              <a href="#" className="hover:text-[#8B3A3A] transition-colors">Cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
